module.exports = __webpack_public_path__ + "media/6.0015bfa2.mp3";